import * as Sentry from "@sentry/react";

const SENTRY_DSN_DEFAULT =
  "https://c63d3fbaeaebacce3c6074183b2914d6@o4511013564841984.ingest.de.sentry.io/4511019716116560";

const getSentryEnvironment = (): string => {
  const explicitEnv = process.env.REACT_APP_ENV;
  if (explicitEnv) return explicitEnv;
  return process.env.NODE_ENV === "production" ? "production" : "local";
};

export const initSentry = (): void => {
  const dsn = process.env.REACT_APP_SENTRY_DSN || SENTRY_DSN_DEFAULT;
  const environment = getSentryEnvironment();

  Sentry.init({
    dsn,
    environment,
    enableLogs: true,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    attachStacktrace: true,
    sendDefaultPii: true,
  });

  Sentry.captureMessage(`Donate web startup ping (${environment})`, "info");
};

export const captureException = (
  error: unknown,
  context: {
    tags?: Record<string, string>;
    extras?: Record<string, unknown>;
  } = {}
): void => {
  Sentry.withScope((scope) => {
    if (context.tags) {
      Object.entries(context.tags).forEach(([key, value]) => scope.setTag(key, value));
    }
    if (context.extras) {
      Object.entries(context.extras).forEach(([key, value]) => scope.setExtra(key, value as any));
    }
    Sentry.captureException(error instanceof Error ? error : new Error(String(error)));
  });
};
